import moment from "moment";

export const endDateOfCurrentMonth = () => {
  return moment().endOf("month").format("YYYY-MM-DD");
};
